import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { FormBuilder, FormGroup, NgbModal, Observable, Router, Subject, Validators } from 'src/app/common/angular.index';
import { ALERTS } from 'src/app/common/enums';
import { AppConstants, IApplication, ICompany, IMenuOption, IPermission } from 'src/app/models';
import { AlertService, StorageService } from 'src/app/services';
import { BlockUIHandlerService } from 'src/app/services/block-uihandler.service';
import { CommonService } from 'src/app/services/common.service';
import { CompanyService } from 'src/app/services/company.service';
import { SideBarService } from 'src/app/services/side-bar.service';
import Swal from 'sweetalert2';
import { PopoutModalName, POPOUT_MODALS } from 'src/app/services/popout.tokens';
import {PopoutService} from 'src/app/services/popout.service'
@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.css']
})
export class ApplicationComponent implements OnInit, OnDestroy {
  //VARBOX
  applications: IApplication[];
  isRaisedFromEvent: boolean;
  menu: IMenuOption[];
  company: ICompany;
  modalReference: NgbModalRef;
  @ViewChild('content') modal: ElementRef;
  companies: ICompany[];
  companiesClone: ICompany[];

  companyForm: FormGroup;
  applicationForm: FormGroup;
  isOnEditMode: boolean;

  companyName: string;
  companyName$: Subject<string>;

  subsCription: Subscription;

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && !this.company) {
      this.GoToHome();
    }
  }


  constructor(
    private companyService: CompanyService
    , private blockUIHandler: BlockUIHandlerService
    , private modalService: NgbModal
    , private formBuilder: FormBuilder
    , private alertService: AlertService
    , private router: Router
    , private commonService: CommonService
    , private sidebarService: SideBarService
    , private storageService: StorageService
  ) {
    this.companyName$ = new Subject<string>();
  }



  ngOnDestroy(): void {
    this.commonService.appOrCompanyHeaderTittle.next({ ObjecName: '', From: 0 });
    if (this.subsCription)
      this.subsCription.unsubscribe();
  }




  ngOnInit(): void {
    this.InitVariables();
    this.subsCription = this.commonService.appOrCompanyChange.subscribe(next => {

      if (next === 1)
        this.RaisedFromEvent();
    });

  }

  InitVariables(): void {
    this.isRaisedFromEvent = false;
    this.company = null;
    this.menu = AppConstants.GetMenu;
    this.GetCompanies();

  }

  //Filtra la lista de compañias cada vez que el usaurio va 
  FilterCompanyNamesList(res: string) {
    this.companies = (res != "") ? this.companiesClone.filter(c => c.Name.toUpperCase().includes(res.toUpperCase())) : this.companiesClone;
  }

  SetCompany(): void {
    this.company = this.companies.find(x => x.UIsSelected);
    if (!this.company) {
      this.alertService.ShowSmallCornerAlert(`Seleccione una compañía por favor`, ALERTS.info);
      return;
    }
    this.ResetApplicationForm();
    this.DismissCompanyModal();
    this.GetApplications(this.company?.Id);
  }

  ResetCompanyForm(): void {
    this.companyForm = this.formBuilder.group({
      Id: [-1],
      Name: ['', Validators.required],
      Key: ['', Validators.required],
      Active: ['', Validators.required]
    });
  }



  RaisedFromEvent(): void {
    this.isRaisedFromEvent = true;
    this.GetCompanies();
  }

  GetCompanies(): void {
    this.blockUIHandler.Start(1, `Procesando, espere por favor`);
    this.companyService.GetCompanies().pipe(finalize(() => this.blockUIHandler.Stop())).subscribe(next => {
      if (next?.Result && next.Data.length > 0) {
        this.companies = next.Data.filter(x => x.Active);
        this.companiesClone = this.companies;
        this.RaiseCompanyModal(this.modal);

      }
      else {

      }
    }, error => {
      console.log(error);
    });
  }

  RaiseCompanyModal(content): void {
    this.ResetCompanyForm();

    this.modalReference = this.modalService.open(content, {
      centered: true,
      backdrop: 'static',

    });
  }

  SelectCompany(_id: number): void {
    this.companies.forEach(x => x.UIsSelected = false);
    this.companies.find(x => x.Id === _id).UIsSelected = true;
  }

  DismissCompanyModal(): void {
    this.modalReference.close();
  }

  GoToHome(): void {
    this.DismissCompanyModal();
    if (!this.isRaisedFromEvent) {
      this.menu.forEach(x => {
        x.Selected = false;
        if (x.Children.length > 0) {
          x.Children.forEach(y => y.Selected = false);
        }
      });
      this.menu.find(x => x.Name === 'Inicio').Selected = true;
      this.sidebarService.currentPath.next('Inicio');
      this.alertService.ShowSmallCornerAlert(`Sin seleccionar la compañía no se puede acceder a esta configuración`, ALERTS.info);
      this.router.navigateByUrl('/home');
    }
  }


  GetApplications(_companyId: number): void {
    this.blockUIHandler.Start(1, `Procesando, espere por favor`);
    this.companyService.GetCompanyApplications(_companyId).pipe(finalize(() => this.blockUIHandler.Stop())
    ).subscribe(next => {
      if (next?.Result) {
        this.applications = next.Data;
        this.commonService.appOrCompanyHeaderTittle.next({ ObjecName: this.company.Name, From: 1 });
      }
    }, error => {
      console.info(error);
    });
  }


  //----------------------------------------001

  ResetApplicationForm(): void {
    const BASE_PATH = this.storageService.GetBasePath();
    this.applicationForm = this.formBuilder.group({
      Id: [-1],
      Name: ['', Validators.required],
      Active: [true, Validators.required],
      FilesPath: [BASE_PATH, Validators.required],
      CompanyId: [this.company.Id]
    });
  }

  RiseCreateUpdateModal(content: any, app: IApplication, isEditMode: boolean): void {
    this.isOnEditMode = isEditMode;
    if (app)

      this.applicationForm.patchValue({
        Id: app.Id,
        Name: app.Name,
        FilesPath: app.FilesPath,
        CompanyId: app.CompanyId,
        Active: app.Active
      });

    this.modalReference = this.modalService.open(content, {
      centered: true,
      backdrop: 'static',
    });
  }

  CloseCreateUpdateModal(): void {
    this.ResetApplicationForm();
    this.modalReference.close();
  }

  UpdateApplication(): void {
    const app = this.applicationForm.value as IApplication;
    this.blockUIHandler.Start(1, 'Procesando, espere por favor');
    this.companyService.UpdateApplication(app).pipe(finalize(() => this.blockUIHandler.Stop())).subscribe(next => {
      if (next?.Result) {
        this.CloseCreateUpdateModal();
        this.alertService.ShowSmallCornerAlert(`Procesado con éxito`, ALERTS.success);
        this.GetApplications(this.company.Id);
      }

    }, err => {
      this.alertService.errorAlert(AppConstants.GetError(err));
    });
  }

  CreateApplication(): void {

    if (this.applicationForm.invalid) {
      this.alertService.infoAlert('Completar todos los campos.');
      return;
    }

    const app = this.applicationForm.value as IApplication;

    this.blockUIHandler.Start(1, 'Creando aplicación');

    this.companyService.CreateApplication(app).pipe(finalize(() => this.blockUIHandler.Stop())).subscribe(next => {

      if (next?.Result) {
        this.alertService.successAlert('Aplicación creada con éxito.');
        this.GetApplications(this.company.Id);
        this.CloseCreateUpdateModal();

      }
    }, err => {
      let error = AppConstants.GetError(err)
      this.alertService.ShowBigCenteredAlert(error, ALERTS.error);

    });

  }

  OnclickSaveApp(): void {
    this.isOnEditMode ? this.UpdateApplication() : this.CreateApplication();
  }



// Abre el tab de reportes al darle click al icono de reporte de cada app
  OpenReportOnNewWindow() { 
    // const url = this.router.serializeUrl(this.router.createUrlTree(['reports-crud/1/2']));
    // window.open(url, '_blank');
    //this.router.navigate(['reports-crud']);
    // //Data que sera enviada al componente de reportes
    // const modalData = {
    //   modalName: PopoutModalName.ReportComponent,
    //   AppKey:app.Key,
    //   CompanyKey:this.company.Key
    
    // };

    // if (!this.popoutService.isPopoutWindowOpen()) {
    //   this.popoutService.openPopoutModal(modalData);
    // } else {
    //   // Aqui deberia abrir un nuvo tab cada que la appKey sea diferente
    //   const sameApp = POPOUT_MODALS['componentInstance'].AppKey === app.Key;
    //   // When popout modal is open and there is no change in data, focus on popout modal
    //   if (sameApp) {
    //     this.popoutService.focusPopoutWindow();
    //   } else {
    //     POPOUT_MODALS['outlet'].detach();
    //     const injector = this.popoutService.createInjector(modalData);
    //     const componentInstance = this.popoutService.attachReportsContainer(POPOUT_MODALS['outlet'], injector);
    //     POPOUT_MODALS['componentInstance'] = componentInstance;
    //     this.popoutService.focusPopoutWindow();
    //   }
    // }
  }
}
